var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-group"},[_c('el-select',{model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }